/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { GroupedQuotes } from "./GroupedQuotes";
import {
  GroupedQuotesFromJSON,
  GroupedQuotesFromJSONTyped,
  GroupedQuotesToJSON,
  GroupedQuotesToJSONTyped,
} from "./GroupedQuotes";
import type { EmailQuoteRequestAndResponses } from "./EmailQuoteRequestAndResponses";
import {
  EmailQuoteRequestAndResponsesFromJSON,
  EmailQuoteRequestAndResponsesFromJSONTyped,
  EmailQuoteRequestAndResponsesToJSON,
  EmailQuoteRequestAndResponsesToJSONTyped,
} from "./EmailQuoteRequestAndResponses";

/**
 *
 * @export
 * @interface ManageQuotesTabData
 */
export interface ManageQuotesTabData {
  /**
   *
   * @type {Array<GroupedQuotes>}
   * @memberof ManageQuotesTabData
   */
  quotes: Array<GroupedQuotes>;
  /**
   *
   * @type {Quote}
   * @memberof ManageQuotesTabData
   */
  cheapestQuote?: Quote | null;
  /**
   *
   * @type {Array<EmailQuoteRequestAndResponses>}
   * @memberof ManageQuotesTabData
   */
  emailQuoteRequests: Array<EmailQuoteRequestAndResponses>;
  /**
   *
   * @type {boolean}
   * @memberof ManageQuotesTabData
   */
  manualQuoting: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ManageQuotesTabData
   */
  manualQuotingOpen: boolean;
  /**
   *
   * @type {string}
   * @memberof ManageQuotesTabData
   */
  manualQuotingNotes: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ManageQuotesTabData
   */
  manualQuotingOpenedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the ManageQuotesTabData interface.
 */
export function instanceOfManageQuotesTabData(
  value: object,
): value is ManageQuotesTabData {
  if (!("quotes" in value) || value["quotes"] === undefined) return false;
  if (
    !("emailQuoteRequests" in value) ||
    value["emailQuoteRequests"] === undefined
  )
    return false;
  if (!("manualQuoting" in value) || value["manualQuoting"] === undefined)
    return false;
  if (
    !("manualQuotingOpen" in value) ||
    value["manualQuotingOpen"] === undefined
  )
    return false;
  if (
    !("manualQuotingNotes" in value) ||
    value["manualQuotingNotes"] === undefined
  )
    return false;
  return true;
}

export function ManageQuotesTabDataFromJSON(json: any): ManageQuotesTabData {
  return ManageQuotesTabDataFromJSONTyped(json, false);
}

export function ManageQuotesTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ManageQuotesTabData {
  if (json == null) {
    return json;
  }
  return {
    quotes: (json["quotes"] as Array<any>).map(GroupedQuotesFromJSON),
    cheapestQuote:
      json["cheapestQuote"] == null
        ? undefined
        : QuoteFromJSON(json["cheapestQuote"]),
    emailQuoteRequests: (json["emailQuoteRequests"] as Array<any>).map(
      EmailQuoteRequestAndResponsesFromJSON,
    ),
    manualQuoting: json["manualQuoting"],
    manualQuotingOpen: json["manualQuotingOpen"],
    manualQuotingNotes: json["manualQuotingNotes"],
    manualQuotingOpenedAt:
      json["manualQuotingOpenedAt"] == null
        ? undefined
        : json["manualQuotingOpenedAt"],
  };
}

export function ManageQuotesTabDataToJSON(json: any): ManageQuotesTabData {
  return ManageQuotesTabDataToJSONTyped(json, false);
}

export function ManageQuotesTabDataToJSONTyped(
  value?: ManageQuotesTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quotes: (value["quotes"] as Array<any>).map(GroupedQuotesToJSON),
    cheapestQuote: QuoteToJSON(value["cheapestQuote"]),
    emailQuoteRequests: (value["emailQuoteRequests"] as Array<any>).map(
      EmailQuoteRequestAndResponsesToJSON,
    ),
    manualQuoting: value["manualQuoting"],
    manualQuotingOpen: value["manualQuotingOpen"],
    manualQuotingNotes: value["manualQuotingNotes"],
    manualQuotingOpenedAt: value["manualQuotingOpenedAt"],
  };
}
